import * as React from "react";
import AgGrid from "app/components/AgGrid";
import useAxiosPrivate from "app/hooks/useAxiosPrivate";
import {
    Button,
    Col,
    DateRangePicker,
    Divider,
    Grid,
    Heading,
    Message,
    Panel,
    Row,
    Stack,
    useToaster,
} from "rsuite";
import SideDrawer from "app/components/SideDrawer";
import { LoadingButton } from "@mui/lab";
import { Autocomplete, TextField, Paper, Chip, Tabs, Tab, IconButton, Tooltip } from "@mui/material";
import { Field, Formik } from "formik";
import { DateField, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import moment from "moment";
import * as yup from "yup";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { DeleteForever, InfoOutlined } from "@mui/icons-material";
import ReferenceDetailsDialog from "../References/ReferenceDetailsDialog";
import AddReferenceDialog from "../References/AddReferenceDialog";
import FamilyMemberDetailsDialog from "../Prospects/FamilyMemberDetailsDialog";
import AddFamilyMemberDialog from "../Prospects/AddFamilyMemberDialog";
import useAuth from "app/hooks/useAuth";

import { useTheme } from "@emotion/react";

import { addDays } from "date-fns";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";

import { startOfToday } from "date-fns";
import useAPINew from "app/hooks/useAPINew";
import { DELETE_PREMIUMPOINT, EDIT_PREMIUMPOINT } from "Permissions";
import { toAmnt } from "functions";
import { styled } from "@mui/system";
import { purple } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: purple[500],
    "&:hover": {
        backgroundColor: purple[700],
    },
}));


function getLastFinancialYearDates() {
    const today = startOfToday();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    let startOfLastFY, endOfLastFY;

    if (currentMonth >= 3) {
        // From April to December
        startOfLastFY = new Date(currentYear - 1, 3, 1); // April 1st of last year
        endOfLastFY = new Date(currentYear, 2, 31); // March 31st of this year
    } else {
        // From January to March
        startOfLastFY = new Date(currentYear - 2, 3, 1); // April 1st two years ago
        endOfLastFY = new Date(currentYear - 1, 2, 31); // March 31st of last year
    }

    return {
        startOfLastFY,
        endOfLastFY,
    };
}

const { startOfLastFY, endOfLastFY } = getLastFinancialYearDates();

function getCurrentFinancialYearDates() {
    const today = startOfToday();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    let startOfCurrentFY, endOfCurrentFY;

    if (currentMonth >= 3) {
        // From April to December
        startOfCurrentFY = new Date(currentYear, 3, 1); // April 1st of this year
        endOfCurrentFY = new Date(currentYear + 1, 2, 31); // March 31st of next year
    } else {
        // From January to March
        startOfCurrentFY = new Date(currentYear - 1, 3, 1); // April 1st of last year
        endOfCurrentFY = new Date(currentYear, 2, 31); // March 31st of this year
    }

    return {
        startOfCurrentFY,
        endOfCurrentFY,
    };
}

const { startOfCurrentFY, endOfCurrentFY } = getCurrentFinancialYearDates();

const predefinedRanges = [
    {
        label: "Today",
        value: [new Date(), new Date()],
    },
    {
        label: "Yesterday",
        value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    },
    {
        label: "This week",
        value: [startOfWeek(new Date()), endOfWeek(new Date())],
    },
    {
        label: "Last 7 days",
        value: [subDays(new Date(), 6), new Date()],
    },
    {
        label: "Last 30 days",
        value: [subDays(new Date(), 29), new Date()],
    },
    {
        label: "Last Fin Year",
        value: [startOfLastFY, endOfLastFY],
    },
    {
        label: "Current Fin Year",
        value: [startOfCurrentFY, endOfCurrentFY],
    },
    {
        label: "This month",
        value: [startOfMonth(new Date()), endOfMonth(new Date())],
    },
    {
        label: "Last month",
        value: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1)),
        ],
    },
    {
        label: "Tomorrow",
        value: [addDays(new Date(), 1), addDays(new Date(), 1)],
    },
    {
        label: "Next week",
        value: [
            startOfWeek(addDays(new Date(), 6)),
            endOfWeek(addDays(new Date(), 6)),
        ],
    },
    {
        label: "Next 7 days",
        value: [new Date(), addDays(new Date(), 6)],
    },
    {
        label: "Next 30 days",
        value: [new Date(), addDays(new Date(), 29)],
    },
    {
        label: "Next month",
        value: [
            startOfMonth(addMonths(new Date(), 1)),
            endOfMonth(addMonths(new Date(), 1)),
        ],
    },
];

const validationSchema = yup.object({});

export default function ListPremiumPointNew() {
    const navigate = useNavigate();
    const [familyList, setFamilyList] = React.useState([]);
    const ReferenceList = useAPINew("GetAllReferenceList.php");
    const axiosPrivate = useAxiosPrivate();
    const { permissions, user } = useAuth();

    const [rowData, setRowData] = React.useState([{}]);
    const [total, setTotal] = React.useState([{}]);

    const PaymentByList = useAPINew("GetPaymentByList.php");
    const CashierList = useAPINew("GetCashierList.php");

    const [loading, setLoading] = React.useState(false);
    const [tabValue, setTabValue] = React.useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    React.useEffect(() => {
        onGridReady();
    }, [tabValue]);

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [refDialogOpen, setRefDialogOpen] = React.useState(false);
    const [selectedRefId, setSelectedRefId] = React.useState(null);
    const [refAddDialogOpen, setRefAddDialogOpen] = React.useState(false);

    const [familyMemberViewDialogOpen, setFamilyMemberViewDialogOpen] = React.useState(false);
    const [selectedFamilyMemberId, setSelectedFamilyMemberId] = React.useState(null);
    const [familyMemberAddDialogOpen, setFamilyMemberAddDialogOpen] = React.useState(false);
    const formatNumber = (number) => {
        return Math.floor(number).toLocaleString();
    };
    const formatNumberBalance = (number) => {
        if (number.value < 0) {
            return (number.value * -1).toLocaleString() + " CR";
        } else if (number.value > 0) {
            return (number.value || 0).toLocaleString() + " DR";
        } else {
            return (number.value || 0).toLocaleString();
        }
    };
    const currencyFormatter = (params) => {
        return formatNumber(params.value);
    };
    const formatNumber1 = (number) => {
        if (number.value < 1 && number.value > -1) return 0;
        else return formatNumberBalance(number);
    };

    const [value, setValue] = React.useState([
        startOfMonth(new Date()),
        endOfMonth(new Date()),
    ]);
    var filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            var dateAsString = cellValue;
            if (dateAsString == null) return -1;
            var dateParts = dateAsString.split("/");
            var cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
            );

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }

            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            }
            return 0;
        },
        minValidYear: 1950,
        maxValidYear: 2050,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
        buttons: ["apply", "reset", "clear"],
    };
    const columns = React.useMemo(() => {
        return [
            {
                id: "Date",
                field: "Date",
                minWidth: 120,
                type: "date",
                filter: "agDateColumnFilter",
                filterParams: filterParams,
            },
            { id: "CashierID", field: "CashierID", minWidth: 100, width: 100 },
            { id: "CashierName", field: "CashierName", minWidth: 100, width: 100 },
            { id: "ReceiptNo", field: "ReceiptNo", minWidth: 150 },
            { id: "PolicyNo", field: "PolicyNo", minWidth: 150 },
            { id: "Name", field: "Name", minWidth: 200 },
            { id: "FullName", field: "FullName", minWidth: 200 },
            { id: "FatherName", field: "FatherName", minWidth: 200 },
            { id: "Revival", field: "Revival", minWidth: 100 },
            { id: "Plan", field: "Plan", minWidth: 100 },
            { id: "Term", field: "Term", minWidth: 100 },
            { id: "Mode", field: "Mode", minWidth: 150 },
            { id: "SumAssured", field: "SumAssured", minWidth: 150 },
            { id: "AgencyCode", field: "AgencyCode", minWidth: 150 },
            { id: "Vpo", field: "Vpo", minWidth: 200 },
            { id: "Tehsil", field: "Tehsil", minWidth: 200 },
            { id: "District", field: "District", minWidth: 200 },
            { id: "PinCode", field: "PinCode", minWidth: 200 },
            { id: "Mobile", field: "Mobile", minWidth: 200 },
            {
                id: "FUP",
                field: "FUP",
                minWidth: 120,
                type: "date",
                filter: "agDateColumnFilter",
                filterParams: filterParams,
                headerName: 'DOC'
            },
            {
                id: "NextDue", field: "NextDue", minWidth: 200, type: "date", filter: "agDateColumnFilter",
                valueFormatter: (params) => {
                    if (params.value && params.value !== "0000-00-00") {
                        return moment(params.value, "YYYY-MM-DD").format("DD/MM/YYYY");
                    }
                    return params.value;
                },
                filterParams: filterParams,
            },
            { id: "ServiceBranch", field: "ServiceBranch", minWidth: 100 },
            {
                id: "PremiumAmount",
                field: "PremiumAmount",
                minWidth: 120,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "Inst",
                field: "Inst",
                minWidth: 100,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "DueFr",
                field: "DueFr",
                minWidth: 100,
            },
            {
                id: "DueTo",
                field: "DueTo",
                minWidth: 100,
            },
            {
                id: "CDACharges",
                field: "CDACharges",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "XCharges",
                field: "XCharges",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "CessAmt",
                field: "CessAmt",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "LateFee",
                field: "LateFee",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "LateFeeDiscount",
                field: "LateFeeDiscount",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "GSTAmt",
                field: "GSTAmt",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "TotAmtDR",
                field: "TotAmtDR",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "Cash",
                field: "Cash",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "Bank",
                field: "Bank",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "Balance",
                field: "Balance",
                minWidth: 100,
                valueFormatter: formatNumber1,
            },
            { id: "PaymentBy", field: "PaymentBy", minWidth: 200 },
            { id: "Remark", field: "Remark", minWidth: 200 },

            {
                field: "Reference",
                minWidth: 200,
                editable: false,
                headerName: "Reference",
                cellStyle: {
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                },
            },
            {
                field: "FamilyMemberName",
                minWidth: 200,
                editable: false,
                headerName: "Family Member",
            },
            { field: "AddedBy", minWidth: 150, editable: false },
            {
                field: "Added",
                headerName: "Added On",
                minWidth: 180,
                editable: false,
                type: "date",
                filter: "agDateColumnFilter",
                filterParams: filterParams,
            },
            { field: "UniqueID", hide: true, editable: false },
        ];
    }, []);
    const [initialValues, setInitialValues] = React.useState({});
    const toaster = useToaster();
    function GetFamilyDetails(FamilyHeadID, setFieldValue = null) {
        axiosPrivate
            .post("GetRelatedFamilyList.php", { UID: FamilyHeadID })
            .then((response) => {
                const result = response.data;
                if (result.status === 1) {
                    setFamilyList(result.Data);
                    if (setFieldValue && result.Data && result.Data.length > 0) {
                        setFieldValue("FamilyMemberID", result.Data[0]);
                    }
                }
                if (result.status === 0) {
                    setFamilyList([{ value: "", title: "" }]);
                    if (setFieldValue) {
                        setFieldValue("FamilyMemberID", { value: "", title: "" });
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    const GetDataByID = async (ID) => {
        try {
            const responce = await axiosPrivate.post("GetPremiumPointByIDNew.php", {
                UID: ID,
            });
            //console.log(responce);
            const result = responce.data;
            if (result.status === 1) {
                const newData2 = {
                    UniqueID: result.Data[0]?.UniqueID,
                    ReceiptNo: result.Data[0]?.ReceiptNo,
                    CashierId: result.Data[0]?.CashierID
                        ? {
                            title: result.Data[0]?.CashierID,
                            value: result.Data[0]?.CashierID,
                        }
                        : { title: "", value: "" },
                    CashierName: result.Data[0]?.CashierName,
                    CDACharges: result.Data[0]?.CDACharges,
                    CessAmt: result.Data[0]?.CessAmt,
                    GSTAmt: result.Data[0]?.GSTAmt,
                    Inst: result.Data[0]?.Inst,
                    DueFr: result.Data[0]?.DueFr || "",
                    DueTo: result.Data[0]?.DueTo || "",
                    LateFee: result.Data[0]?.LateFee,
                    LateFeeDiscount: result.Data[0]?.LateFeeDiscount,
                    Name: result.Data[0]?.Name,
                    FullName: result.Data[0]?.FullName,
                    FatherName: result.Data[0]?.FatherName,
                    Vpo: result.Data[0]?.Vpo,
                    Tehsil: result.Data[0]?.Tehsil,
                    District: result.Data[0]?.District,
                    PinCode: result.Data[0]?.PinCode,
                    Mobile: result.Data[0]?.Mobile,
                    Revival: result.Data[0]?.Revival,
                    Plan: result.Data[0]?.Plan,
                    Term: result.Data[0]?.Term,
                    Mode: result.Data[0]?.Mode,
                    SumAssured: result.Data[0]?.SumAssured,
                    AgencyCode: result.Data[0]?.AgencyCode,
                    PolicyNo: result.Data[0]?.PolicyNo,
                    ReferenceID: result.Data[0]?.ReferenceID
                        ? {
                            title: result.Data[0]?.Reference,
                            value: result.Data[0]?.ReferenceID,
                        }
                        : { title: "", value: "" },
                    FamilyMemberID: result.Data[0]?.FamilyMemberID
                        ? {
                            title: result.Data[0]?.FamilyMemberName,
                            value: result.Data[0]?.FamilyMemberID,
                        }
                        : { title: "", value: "" },
                    PremiumAmount: result.Data[0]?.PremiumAmount,
                    ServiceBranch: result.Data[0]?.ServiceBranch,
                    TotAmtDR: result.Data[0]?.TotAmtDR,
                    XCharges: result.Data[0]?.XCharges,
                    Cash: result.Data[0]?.Cash,
                    Bank: result.Data[0]?.Bank,
                    Balance: result.Data[0]?.Balance,
                    Remark: result.Data[0]?.Remark,
                    AssignedTo:
                        result.Data[0].AssignedTo === ""
                            ? null
                            : {
                                value: result.Data[0].AssignedTo,
                                title: result.Data[0].AssignedToName,
                            },
                    PaymentBy: result.Data[0]?.PaymentBy
                        ? {
                            value: result.Data[0]?.PaymentBy,
                            title: result.Data[0]?.PaymentBy,
                        }
                        : { value: "", title: "" },

                    NextDue:
                        result.Data[0].NextDue === "0000-00-00" || result.Data[0].NextDue === null
                            ? null
                            : new Date(result.Data[0].NextDue),
                    FUP:
                        result.Data[0].FUP === "0000-00-00" || result.Data[0].FUP === null
                            ? null
                            : new Date(result.Data[0].FUP),
                    Date:
                        result.Data[0].Date === "0000-00-00" || result.Data[0].Date === null
                            ? null
                            : new Date(result.Data[0].Date),
                };
                setInitialValues(newData2);
                if (result.Data[0]?.ReferenceID) {
                    GetFamilyDetails(result.Data[0].ReferenceID);
                }
            }
            if (result.status === 0) {
                toaster.push(
                    <Message type="error" bordered showIcon>
                        <strong>Error!</strong> {result?.Error}
                    </Message>
                );
            }
        } catch (error) {
            console.log(error);
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error!</strong> Error occured
                </Message>
            );
        }
    };

    const [selectedRowData, setSelectedRowData] = React.useState([]);
    const [filteredRows, setFilteredRows] = React.useState([]);

    React.useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed)
            if (selectedRowData?.UniqueID) {
                GetDataByID(selectedRowData.UniqueID);
            }
        return () => {
            isSubscribed = false;
        };
    }, [selectedRowData?.UniqueID, selectedRowData]);

    const Remove = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div style={{
                        padding: "30px",
                        background: "#fff",
                        borderRadius: "12px",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                        textAlign: "center",
                        minWidth: "350px",
                        fontFamily: "system-ui, -apple-system, sans-serif"
                    }}>
                        <DeleteForever style={{ fontSize: 64, color: "#f44336", marginBottom: 15 }} />
                        <h2 style={{ margin: "0 0 10px", fontSize: "24px", fontWeight: "600", color: "#333" }}>Are you sure?</h2>
                        <p style={{ margin: "0 0 25px", fontSize: "15px", color: "#666" }}>Do you really want to delete this record?<br />This action cannot be undone.</p>
                        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
                            <button
                                onClick={onClose}
                                style={{
                                    padding: "10px 20px",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    background: "#fff",
                                    color: "#333",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    transition: "background 0.2s"
                                }}
                                onMouseOver={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                onMouseOut={(e) => e.currentTarget.style.background = '#fff'}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={async () => {
                                    try {
                                        const datatosend = {
                                            ID: initialValues.UniqueID,
                                        };
                                        const response = await axiosPrivate.post(
                                            "/RemovePremiumPointNew.php",
                                            datatosend
                                        );
                                        const result = response.data;
                                        if (result.status === 1) {
                                            toaster.push(
                                                <Message type="success" header="Success">
                                                    {result.Success}
                                                </Message>,
                                                { placement: "topEnd" },
                                                { duration: 1000 }
                                            );
                                        }
                                        onClose();
                                        handleClose()
                                        onGridReady();
                                        if (result.status === 0) {
                                            toaster.push(
                                                <Message type="error" header="Error">
                                                    {`Error occured`}
                                                </Message>,
                                                { placement: "topEnd" },
                                                { duration: 1000 }
                                            );
                                        }
                                    } catch (err) {
                                        console.error(err);
                                    }
                                }}
                                style={{
                                    padding: "10px 20px",
                                    borderRadius: "6px",
                                    border: "none",
                                    background: "#f44336",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    transition: "background 0.2s"
                                }}
                                onMouseOver={(e) => e.currentTarget.style.background = '#d32f2f'}
                                onMouseOut={(e) => e.currentTarget.style.background = '#f44336'}
                            >
                                Yes, Delete it!
                            </button>
                        </div>
                    </div>
                );
            },
        });
    };

    const clearAll = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui">
                        <h1>{`Are you sure?`}</h1>
                        <p>{`You want to delete all?`}</p>
                        <button onClick={onClose}>No</button>
                        <button
                            onClick={async () => {
                                try {
                                    const datatosend = {
                                        ID: initialValues?.UID,
                                    };
                                    const response = await axiosPrivate.post(
                                        "/RemoveAllPremiumPointNew.php",
                                        datatosend
                                    );
                                    const result = response.data;
                                    if (result.status === 1) {
                                        toaster.push(
                                            <Message type="success" header="Success">
                                                {result.Success}
                                            </Message>,
                                            { placement: "topEnd" },
                                            { duration: 1000 }
                                        );
                                    }
                                    onClose();

                                    if (result.status === 0) {
                                        toaster.push(
                                            <Message type="error" header="Error">
                                                {`Error occured`}
                                            </Message>,
                                            { placement: "topEnd" },
                                            { duration: 1000 }
                                        );
                                    }
                                } catch (err) {
                                    console.error(err);
                                }
                            }}
                        >
                            Yes, Delete it!
                        </button>
                    </div>
                );
            },
        });
    };

    const onGridReady = React.useCallback(
        (params) => {
            setLoading(true);
            const apiEndpoint = tabValue === 1 ? "LoadPendingReferencePremiumPoint.php" : "LoadPremiumPointNew.php";
            const apiPayload = tabValue === 1 ? {} : {
                Start: moment(value[0]).format("YYYY-MM-DD"),
                End: moment(value[1]).format("YYYY-MM-DD"),
            };

            axiosPrivate
                .post(apiEndpoint, apiPayload)
                .then((responce) => {
                    const result = responce.data;
                    if (result.status === 1) {
                        setRowData(result.Data);
                        setTotal(result.Total);
                    } else setRowData([]);
                    setLoading(false);
                })
                .catch((e) => {
                    console.log(e);
                    setLoading(false);
                });
            setLoading(false);
        },
        [value, tabValue]
    );

    return (
        <>
            <Paper
                elevation={2}
                style={{ width: "100%", padding: 10, marginBottom: 15, borderRadius: 8 }}
            >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        style={{ alignItems: "center" }}
                    >
                        <DateRangePicker
                            ranges={predefinedRanges}
                            value={value}
                            onChange={setValue}
                            cleanable={false}
                            format="dd-MM-yyyy"
                            defaultCalendarValue={[
                                new Date("2022-02-01"),
                                new Date("2022-03-01"),
                            ]}
                        />
                        <Button appearance="primary" color="blue" onClick={onGridReady}>
                            Apply
                        </Button>
                    </Stack>

                    <Heading
                        level={5}
                        style={{
                            textAlign: "center",
                            color: "#1e3c72",
                            fontWeight: "bold"
                        }}
                    >
                        Premium Point A0099719G
                    </Heading>

                    <Stack direction="row" spacing={2} style={{ alignItems: "center" }}>
                        <Chip label={`Total: ${toAmnt(total.TotAmtDR)}`} color="primary" variant="outlined" />
                        <Chip label={`Cash: ${toAmnt(total.Cash)}`} color="success" variant="outlined" />
                        <Chip label={`Bank: ${toAmnt(total.Bank)}`} color="info" variant="outlined" />
                        <Chip label={`Balance: ${toAmnt(total.Balance)}`} color={total.Balance > 0 ? "error" : "default"} />

                        <Button
                            disabled={!permissions.includes(10000)}
                            onClick={clearAll}
                            color="red"
                            appearance="subtle"
                        >
                            <DeleteForever /> Clear All
                        </Button>
                    </Stack>
                </div>
            </Paper>
            <Paper
                elevation={2}
                style={{
                    width: "100%",
                    maxHeight: 600,
                    marginTop: 5,
                    borderRadius: 8,
                    overflowY: "auto",
                }}
            >
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    style={{ borderBottom: '1px solid #e0e0e0', padding: '0 10px' }}
                >
                    <Tab label="All Records" />
                    <Tab label="Pending Reference" />
                </Tabs>
                <Panel>
                    <AgGrid
                        columns={columns}
                        rowData={rowData}
                        onGridReady={onGridReady}
                        defaultColumn={["Name"]}
                        GoTo="/Policy/View"
                        showLoading={loading}
                        onRowSelectedData={setSelectedRowData}
                        handleViewModalOpen={handleOpen}
                        settingsName="Policy"
                        headerComponent={() => <p></p>}
                        setFilteredRows={setFilteredRows}
                        Source="PremiumPoint"
                        exportAllowed={true}
                    />
                </Panel>
            </Paper>

            <SideDrawer
                open={open}
                onClose={handleClose}
                title="Update Premium Point"
            >
                <Formik
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    enableReinitialize={true}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        const newData = {
                            ...values,
                            CashierId: values.CashierId?.value,
                            PaymentBy: values.PaymentBy?.value,
                            FUP: values.FUP ? moment(values.FUP).format("YYYY-MM-DD") : null,
                            Date: values.Date ? moment(values.Date).format("YYYY-MM-DD") : null,
                            NextDue: values.NextDue ? moment(values.NextDue).format("YYYY-MM-DD") : null,
                            ReferenceID: values.ReferenceID?.value,
                            FamilyMemberID: values.FamilyMemberID?.value,
                        };
                        //console.log(newData);
                        try {
                            axiosPrivate
                                .post("EditPremiumPointNew.php", newData)
                                .then((response) => {
                                    const result = response.data;
                                    if (result.status === 1) {
                                        toaster.push(
                                            <Message type="success" bordered showIcon style={{ left: "auto", right: "auto", marginLeft: "50%" }}>
                                                <strong>Success!</strong> {result.Success}
                                            </Message>
                                        );

                                        onGridReady();
                                        setSubmitting(false);
                                        handleClose()
                                    }
                                    if (result.status === 0) {
                                        toaster.push(
                                            <Message type="error" bordered showIcon>
                                                <strong>Error!</strong> {result.Error}
                                            </Message>
                                        );
                                        setSubmitting(false);
                                    }
                                })
                                .catch((error) => {
                                    console.error("Error submitting data:", error);
                                    setSubmitting(false);
                                });
                        } catch (e) {
                            console.log(e);
                        } finally {
                            setSubmitting(false);
                        }
                        // updateDatainGrid(newData, values.UniqueID);
                    }}
                >
                    {({
                        values,
                        errors,
                        setFieldValue,
                        handleSubmit,
                        isValidating,
                        isSubmitting,
                        touched,
                        handleBlur,
                        handleChange,
                    }) => {
                        // console.log(errors);
                        // console.log(values);
                        return (
                            <form>
                                <div>
                                    <div className="row">
                                        <Stack spacing={2} direction="column" alignItems="stretch" style={{ padding: 8, marginTop: 8 }}>

                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DateField
                                                    label="Date"
                                                    variant="standard"
                                                    size="small"
                                                    name="Date"
                                                    format="dd-MM-yyyy"
                                                    value={values.Date}
                                                    onChange={(value) =>
                                                        setFieldValue("Date", value, true)
                                                    }
                                                    onBlur={handleBlur}
                                                    error={touched.Date && Boolean(errors.Date)}
                                                    helperText={touched.Date && errors.Date}
                                                />
                                            </LocalizationProvider>




                                            <Field
                                                fullWidth
                                                name={`CashierName`}
                                                variant="standard"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.CashierName),
                                                }}
                                                label="Cashier Name"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Cashier Name"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.CashierName && Boolean(errors.CashierName)
                                                }
                                                helperText={touched.CashierName && errors.CashierName}
                                            />

                                            <Field
                                                fullWidth
                                                name={`ReceiptNo`}
                                                variant="standard"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.ReceiptNo),
                                                }}
                                                label="Receipt No"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Receipt No"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.ReceiptNo && Boolean(errors.ReceiptNo)
                                                }
                                                helperText={touched.ReceiptNo && errors.ReceiptNo}
                                            />


                                            <Field
                                                fullWidth
                                                name={`PolicyNo`}
                                                variant="standard"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.PolicyNo),
                                                }}
                                                label="Policy No"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Policy No"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.PolicyNo && Boolean(errors.PolicyNo)
                                                }
                                                helperText={touched.PolicyNo && errors.PolicyNo}
                                            />


                                            <Field
                                                fullWidth
                                                name={`Name`}
                                                variant="standard"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.Name),
                                                }}
                                                label="Name"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Name"
                                                onBlur={handleBlur}
                                                error={touched.Name && Boolean(errors.Name)}
                                                helperText={touched.Name && errors.Name}
                                            />

                                            <Field
                                                fullWidth
                                                name={`FullName`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.FullName) }}
                                                label="Full Name"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Full Name"
                                                onBlur={handleBlur}
                                                error={touched.FullName && Boolean(errors.FullName)}
                                                helperText={touched.FullName && errors.FullName}
                                            />

                                            <Field
                                                fullWidth
                                                name={`FatherName`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.FatherName) }}
                                                label="Father/Other Name"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Father Name"
                                                onBlur={handleBlur}
                                                error={touched.FatherName && Boolean(errors.FatherName)}
                                                helperText={touched.FatherName && errors.FatherName}
                                            />

                                            <Field
                                                fullWidth
                                                name={`Vpo`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.Vpo) }}
                                                label="VPO"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter VPO"
                                                onBlur={handleBlur}
                                                error={touched.Vpo && Boolean(errors.Vpo)}
                                                helperText={touched.Vpo && errors.Vpo}
                                            />

                                            <Field
                                                fullWidth
                                                name={`Tehsil`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.Tehsil) }}
                                                label="Tehsil"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Tehsil"
                                                onBlur={handleBlur}
                                                error={touched.Tehsil && Boolean(errors.Tehsil)}
                                                helperText={touched.Tehsil && errors.Tehsil}
                                            />

                                            <Field
                                                fullWidth
                                                name={`District`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.District) }}
                                                label="District"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter District"
                                                onBlur={handleBlur}
                                                error={touched.District && Boolean(errors.District)}
                                                helperText={touched.District && errors.District}
                                            />

                                            <Field
                                                fullWidth
                                                name={`PinCode`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.PinCode) }}
                                                label="Pin Code"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Pin Code"
                                                onBlur={handleBlur}
                                                error={touched.PinCode && Boolean(errors.PinCode)}
                                                helperText={touched.PinCode && errors.PinCode}
                                            />

                                            <Field
                                                fullWidth
                                                name={`Mobile`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.Mobile) }}
                                                label="Mobile"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Mobile"
                                                onBlur={handleBlur}
                                                error={touched.Mobile && Boolean(errors.Mobile)}
                                                helperText={touched.Mobile && errors.Mobile}
                                            />

                                            <Field
                                                fullWidth
                                                name={`Revival`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.Revival) }}
                                                label="Revival"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Revival"
                                                onBlur={handleBlur}
                                                error={touched.Revival && Boolean(errors.Revival)}
                                                helperText={touched.Revival && errors.Revival}
                                            />

                                            <Field
                                                fullWidth
                                                name={`Plan`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.Plan) }}
                                                label="Plan"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Plan"
                                                onBlur={handleBlur}
                                                error={touched.Plan && Boolean(errors.Plan)}
                                                helperText={touched.Plan && errors.Plan}
                                            />

                                            <Field
                                                fullWidth
                                                name={`Term`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.Term) }}
                                                label="Term"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Term"
                                                onBlur={handleBlur}
                                                error={touched.Term && Boolean(errors.Term)}
                                                helperText={touched.Term && errors.Term}
                                            />

                                            <Field
                                                fullWidth
                                                name={`Mode`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.Mode) }}
                                                label="Mode"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Mode"
                                                onBlur={handleBlur}
                                                error={touched.Mode && Boolean(errors.Mode)}
                                                helperText={touched.Mode && errors.Mode}
                                            />

                                            <Field
                                                fullWidth
                                                name={`SumAssured`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.SumAssured) }}
                                                label="Sum Assured"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Sum Assured"
                                                onBlur={handleBlur}
                                                error={touched.SumAssured && Boolean(errors.SumAssured)}
                                                helperText={touched.SumAssured && errors.SumAssured}
                                            />

                                            <Field
                                                fullWidth
                                                name={`AgencyCode`}
                                                variant="standard"
                                                InputLabelProps={{ shrink: Boolean(values.AgencyCode) }}
                                                label="Agency Code"
                                                size="small"
                                                as={TextField}
                                                placeholder="Enter Agency Code"
                                                onBlur={handleBlur}
                                                error={touched.AgencyCode && Boolean(errors.AgencyCode)}
                                                helperText={touched.AgencyCode && errors.AgencyCode}
                                            />


                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DateField
                                                    label="FUP"
                                                    variant="standard"
                                                    size="small"
                                                    name="FUP"
                                                    format="dd-MM-yyyy"
                                                    value={values.FUP}
                                                    onChange={(value) =>
                                                        setFieldValue("FUP", value, true)
                                                    }
                                                    onBlur={handleBlur}
                                                    error={touched.FUP && Boolean(errors.FUP)}
                                                    helperText={touched.FUP && errors.FUP}
                                                />
                                            </LocalizationProvider>

                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DateField
                                                    label="Next Due"
                                                    variant="standard"
                                                    size="small"
                                                    name="NextDue"
                                                    format="dd-MM-yyyy"
                                                    value={values.NextDue}
                                                    onChange={(value) =>
                                                        setFieldValue("NextDue", value, true)
                                                    }
                                                    onBlur={handleBlur}
                                                    error={touched.NextDue && Boolean(errors.NextDue)}
                                                    helperText={touched.NextDue && errors.NextDue}
                                                />
                                            </LocalizationProvider>



                                            <Field
                                                name={`ServiceBranch`}
                                                fullWidth
                                                label="ServiceBranch"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.ServiceBranch),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Service Branch"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.ServiceBranch &&
                                                    Boolean(errors.ServiceBranch)
                                                }
                                                helperText={
                                                    touched.ServiceBranch && errors.ServiceBranch
                                                }
                                            />


                                            <Field
                                                name={`PremiumAmount`}
                                                fullWidth
                                                label="Premium Amount"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.PremiumAmount),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Premium Amount"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.PremiumAmount &&
                                                    Boolean(errors.PremiumAmount)
                                                }
                                                helperText={
                                                    touched.PremiumAmount && errors.PremiumAmount
                                                }
                                            />


                                            <Field
                                                name={`Inst`}
                                                fullWidth
                                                label="Inst"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.Inst),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Inst"
                                                onBlur={handleBlur}
                                                error={touched.Inst && Boolean(errors.Inst)}
                                                helperText={touched.Inst && errors.Inst}
                                            />


                                            <Field
                                                name={`DueFr`}
                                                fullWidth
                                                label="Due Fr"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.DueFr),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Due Fr"
                                                onBlur={handleBlur}
                                                error={touched.DueFr && Boolean(errors.DueFr)}
                                                helperText={touched.DueFr && errors.DueFr}
                                            />


                                            <Field
                                                name={`DueTo`}
                                                fullWidth
                                                label="Due To"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.DueTo),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Due To"
                                                onBlur={handleBlur}
                                                error={touched.DueTo && Boolean(errors.DueTo)}
                                                helperText={touched.DueTo && errors.DueTo}
                                            />


                                            <Field
                                                name={`CDACharges`}
                                                fullWidth
                                                label="CDACharges"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.CDACharges),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter CDACharges"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.CDACharges && Boolean(errors.CDACharges)
                                                }
                                                helperText={
                                                    touched.CDACharges && errors.CDACharges
                                                }
                                            />


                                            <Field
                                                name={`XCharges`}
                                                fullWidth
                                                label="XCharges"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.XCharges),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter XCharges"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.XCharges && Boolean(errors.XCharges)
                                                }
                                                helperText={touched.XCharges && errors.XCharges}
                                            />


                                            <Field
                                                name={`CessAmt`}
                                                fullWidth
                                                label="CessAmt"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.CessAmt),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter CessAmt"
                                                onBlur={handleBlur}
                                                error={touched.CessAmt && Boolean(errors.CessAmt)}
                                                helperText={touched.CessAmt && errors.CessAmt}
                                            />


                                            <Field
                                                name={`LateFee`}
                                                fullWidth
                                                label="LateFee"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.LateFee),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Late Fee"
                                                onBlur={handleBlur}
                                                error={touched.LateFee && Boolean(errors.LateFee)}
                                                helperText={touched.LateFee && errors.LateFee}
                                            />


                                            <Field
                                                name={`LateFeeDiscount`}
                                                fullWidth
                                                label="Late Fee Discount"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.LateFeeDiscount),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Late Fee Discount"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.LateFeeDiscount &&
                                                    Boolean(errors.LateFeeDiscount)
                                                }
                                                helperText={
                                                    touched.LateFeeDiscount &&
                                                    errors.LateFeeDiscount
                                                }
                                            />


                                            <Field
                                                name={`GSTAmt`}
                                                fullWidth
                                                label="GSTAmt"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.GSTAmt),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter GST Amt"
                                                onBlur={handleBlur}
                                                error={touched.GSTAmt && Boolean(errors.GSTAmt)}
                                                helperText={touched.GSTAmt && errors.GSTAmt}
                                            />


                                            <Field
                                                name={`TotAmtDR`}
                                                fullWidth
                                                label="Total Amt DR"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.TotAmtDR),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                onChange={(E) => {
                                                    handleChange(E);
                                                    let Amnt = E.target.value;
                                                    let Balance =
                                                        parseFloat(Amnt) -
                                                        parseFloat(values.Cash || 0) -
                                                        parseFloat(values.Bank || 0);
                                                    setFieldValue("Balance", Balance);
                                                }}
                                                placeholder="Enter Total Amt DR"
                                                onBlur={handleBlur}
                                                error={
                                                    touched.TotAmtDR && Boolean(errors.TotAmtDR)
                                                }
                                                helperText={touched.TotAmtDR && errors.TotAmtDR}
                                            />


                                            <Field
                                                name={`Cash`}
                                                fullWidth
                                                label="Cash"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.Cash),
                                                }}
                                                onChange={(E) => {
                                                    handleChange(E);
                                                    let Amnt = E.target.value;
                                                    let Balance =
                                                        parseFloat(values.TotAmtDR) -
                                                        parseFloat(Amnt || 0) -
                                                        parseFloat(values.Bank || 0);
                                                    setFieldValue("Balance", Balance);
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Cash"
                                                onBlur={handleBlur}
                                                error={touched.Cash && Boolean(errors.Cash)}
                                                helperText={touched.Cash && errors.Cash}
                                            />


                                            <Field
                                                name={`Bank`}
                                                fullWidth
                                                label="Bank"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.Bank),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                onChange={(E) => {
                                                    handleChange(E);
                                                    let Amnt = E.target.value;
                                                    let Balance =
                                                        parseFloat(values.TotAmtDR) -
                                                        parseFloat(values.Cash || 0) -
                                                        parseFloat(Amnt);
                                                    setFieldValue("Balance", Balance);
                                                }}
                                                placeholder="Enter Bank"
                                                onBlur={handleBlur}
                                                error={touched.Bank && Boolean(errors.Bank)}
                                                helperText={touched.Bank && errors.Bank}
                                            />


                                            <Field
                                                name={`Balance`}
                                                fullWidth
                                                label="Total Balance"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.Balance),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Balance"
                                                onBlur={handleBlur}
                                                error={touched.Balance && Boolean(errors.Balance)}
                                                helperText={touched.Balance && errors.Balance}
                                            />

                                            <Autocomplete
                                                key="CashierId"
                                                name={`CashierId`}
                                                options={
                                                    CashierList.error ? [null] : CashierList.data
                                                }
                                                getOptionLabel={(option) => option?.title}
                                                disableClearable={true}
                                                value={
                                                    Boolean(values.CashierId)
                                                        ? values.CashierId
                                                        : { value: "", title: "" }
                                                }
                                                onBlur={handleBlur}
                                                error={
                                                    touched.CashierId &&
                                                    Boolean(errors.CashierId)
                                                }
                                                helperText={
                                                    touched.CashierId && errors.CashierId
                                                }
                                                onChange={(_, newValue) => {
                                                    setFieldValue(`CashierId`, newValue, true);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="CashierId"
                                                        onBlur={handleBlur}
                                                        error={
                                                            touched.CashierId &&
                                                            Boolean(errors.CashierId)
                                                        }
                                                        helperText={
                                                            touched.CashierId && errors.CashierId
                                                        }
                                                        label="Cashier ID"
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                            <Autocomplete
                                                key="ID"
                                                name={`PaymentBy`}
                                                options={
                                                    PaymentByList.error
                                                        ? [null]
                                                        : PaymentByList.data
                                                }
                                                getOptionLabel={(option) => option?.title}
                                                disableClearable={true}
                                                value={
                                                    Boolean(values.PaymentBy)
                                                        ? values.PaymentBy
                                                        : { value: "", title: "" }
                                                }
                                                onBlur={handleBlur}
                                                error={
                                                    touched.PaymentBy && Boolean(errors.PaymentBy)
                                                }
                                                helperText={touched.PaymentBy && errors.PaymentBy}
                                                onChange={(_, newValue) => {
                                                    console.log(values);
                                                    console.log(errors);
                                                    setFieldValue(`PaymentBy`, newValue, true);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="PaymentBy"
                                                        onBlur={handleBlur}
                                                        error={
                                                            touched.PaymentBy &&
                                                            Boolean(errors.PaymentBy)
                                                        }
                                                        helperText={
                                                            touched.PaymentBy && errors.PaymentBy
                                                        }
                                                        label="Payment By"
                                                        variant="standard"
                                                    />
                                                )}
                                                style={{ width: 200 }}
                                            />


                                            <Field
                                                name={`Remark`}
                                                fullWidth
                                                label="Remark"
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: Boolean(values.Remark),
                                                }}
                                                variant="standard"
                                                as={TextField}
                                                placeholder="Enter Remark"
                                                onBlur={handleBlur}
                                                error={touched.Remark && Boolean(errors.Remark)}
                                                helperText={touched.Remark && errors.Remark}
                                            />


                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Field
                                                    name="ReferenceID"
                                                    component={Autocomplete}
                                                    key="ID"
                                                    options={
                                                        ReferenceList?.error
                                                            ? [{ value: "", title: "" }]
                                                            : ReferenceList.data
                                                    }
                                                    getOptionLabel={(option) => option.title || ""}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    style={{ width: 280 }}
                                                    onBlur={handleBlur} // so formik can see the forms touched state
                                                    onChange={(_, value) => {
                                                        setFieldValue(
                                                            "ReferenceID",
                                                            value || { value: "", title: "" }
                                                        );
                                                        GetFamilyDetails(value.value, setFieldValue);
                                                    }}
                                                    value={
                                                        Boolean(values.ReferenceID)
                                                            ? values.ReferenceID
                                                            : { value: "", title: "" }
                                                    }
                                                    disableClearable={false}
                                                    openOnFocus
                                                    autoHighlight
                                                    autoSelect
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            name="ReferenceID"
                                                            label="ReferenceID"
                                                            variant="standard"
                                                            error={
                                                                touched.ReferenceID &&
                                                                Boolean(errors.ReferenceID)
                                                            }
                                                            helperText={
                                                                touched.ReferenceID && errors.ReferenceID
                                                            }
                                                        />
                                                    )}
                                                />
                                                <Tooltip title="View Reference Details">
                                                    <span>
                                                        <IconButton
                                                            color="primary"
                                                            disabled={!values.ReferenceID?.value}
                                                            onClick={() => {
                                                                setSelectedRefId(values.ReferenceID?.value);
                                                                setRefDialogOpen(true);
                                                            }}
                                                        >
                                                            <InfoOutlined />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <ColorButton
                                                    variant="contained"
                                                    onClick={() => {
                                                        setRefAddDialogOpen(true);
                                                    }}
                                                >
                                                    New
                                                </ColorButton>
                                            </Stack>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Field
                                                    name="FamilyMemberID"
                                                    component={Autocomplete}
                                                    key="ID"
                                                    options={
                                                        familyList?.length > 0
                                                            ? familyList
                                                            : [{ value: "", title: "" }]
                                                    }
                                                    getOptionLabel={(option) => option.title || ""}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    style={{ width: 280 }}
                                                    onBlur={handleBlur} // so formik can see the forms touched state
                                                    onChange={async (_, value) => {
                                                        setFieldValue(
                                                            "FamilyMemberID",
                                                            value || { value: "", title: "" }
                                                        );
                                                        console.log(values);
                                                    }}
                                                    value={
                                                        Boolean(values.FamilyMemberID)
                                                            ? values.FamilyMemberID
                                                            : { value: "", title: "" }
                                                    }
                                                    disableClearable={true}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            name="FamilyMemberID"
                                                            label="Family Member"
                                                            variant="standard"
                                                            error={
                                                                touched.FamilyMemberID &&
                                                                Boolean(errors.FamilyMemberID)
                                                            }
                                                            helperText={
                                                                touched.FamilyMemberID && errors.FamilyMemberID
                                                            }
                                                        />
                                                    )}
                                                />
                                                <Tooltip title="View Family Member Details">
                                                    <span>
                                                        <IconButton
                                                            color="primary"
                                                            disabled={!values.FamilyMemberID?.value}
                                                            onClick={() => {
                                                                setSelectedFamilyMemberId(values.FamilyMemberID?.value);
                                                                setFamilyMemberViewDialogOpen(true);
                                                            }}
                                                        >
                                                            <InfoOutlined />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <ColorButton
                                                    variant="contained"
                                                    disabled={!values.ReferenceID?.value}
                                                    onClick={() => {
                                                        setFamilyMemberAddDialogOpen(true);
                                                    }}
                                                >
                                                    New
                                                </ColorButton>
                                            </Stack>
                                            {/* 
                            <Stack direction="row" spacing={0}>
                              {user.Type === "SuperAdmin" && (
                                <Field
                                  name="AssignedTo"
                                  component={Autocomplete}
                                  key="ID"
                                  options={options.sort(
                                    (a, b) =>
                                      -b.firstLetter.localeCompare(
                                        a.firstLetter
                                      )
                                  )}
                                  groupBy={(option) => option.UserType}
                                  sx={{ width: 300 }}
                                  renderGroup={(params) => (
                                    <li key={params.key}>
                                      <GroupHeader>{params.group}</GroupHeader>
                                      <GroupItems>{params.children}</GroupItems>
                                    </li>
                                  )}
                                  getOptionLabel={(option) =>
                                    option?.title || ""
                                  }
                                  style={{ width: 200 }}
                                  onBlur={handleBlur} // so formik can see the forms touched state
                                  onChange={(_, value) => {
                                    setFieldValue(
                                      "AssignedTo",
                                      value || { value: "", title: "" }
                                    );
                                    console.log(values);
                                  }}
                                  value={
                                    Boolean(values.AssignedTo)
                                      ? values.AssignedTo
                                      : { value: "", title: "" }
                                  }
                                  disableClearable={true}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      name="AssignedTo"
                                      label="AssignedTo"
                                      variant="standard"
                                      error={
                                        touched.AssignedTo &&
                                        Boolean(errors.AssignedTo)
                                      }
                                      helperText={
                                        touched.AssignedTo && errors.AssignedTo
                                      }
                                    />
                                  )}
                                />
                              )}
                            </Stack>
                           */}
                                        </Stack>
                                    </div>
                                    <ReferenceDetailsDialog
                                        open={refDialogOpen}
                                        onClose={() => setRefDialogOpen(false)}
                                        referenceId={selectedRefId}
                                    />
                                    <AddReferenceDialog
                                        open={refAddDialogOpen}
                                        onClose={() => setRefAddDialogOpen(false)}
                                        initialName={values.Name}
                                        initialMobile={values.Mobile}
                                        initialPIN={values.PinCode}
                                        initialTehsil={values.Tehsil}
                                        initialDistrict={values.District}
                                        initialState={values.State}
                                        onSuccess={(newRefId, newRefName) => {
                                            setFieldValue("ReferenceID", { value: newRefId, title: newRefName });
                                            if (ReferenceList?.reload) {
                                                ReferenceList.reload();
                                            }
                                        }}
                                    />
                                    <FamilyMemberDetailsDialog
                                        open={familyMemberViewDialogOpen}
                                        onClose={() => setFamilyMemberViewDialogOpen(false)}
                                        familyMemberId={selectedFamilyMemberId}
                                    />
                                    <AddFamilyMemberDialog
                                        open={familyMemberAddDialogOpen}
                                        onClose={() => setFamilyMemberAddDialogOpen(false)}
                                        referenceId={values.ReferenceID?.value}
                                        onSuccess={(newFamilyMemberId) => {
                                            // Refresh the family list
                                            if (values.ReferenceID?.value) {
                                                GetFamilyDetails(values.ReferenceID.value, setFieldValue);
                                            }
                                        }}
                                    />
                                    <Divider />
                                    &nbsp; &nbsp;
                                    <>
                                        {(permissions.includes(EDIT_PREMIUMPOINT) ||
                                            user.Type === "SuperAdmin") && (
                                                <LoadingButton
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    color="secondary"
                                                    variant="contained"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleSubmit(e);
                                                    }}
                                                    loading={isValidating}
                                                    sx={{ my: 2 }}
                                                >
                                                    {isSubmitting ? "Submitting..." : "Submit"}
                                                </LoadingButton>
                                            )}
                                        &nbsp; &nbsp;
                                        {(permissions.includes(DELETE_PREMIUMPOINT) ||
                                            user.Type === "SuperAdmin") && (
                                                <Button
                                                    color="red"
                                                    appearance="primary"
                                                    sx={{ my: 2 }}
                                                    onClick={Remove}
                                                >
                                                    {"Delete"}
                                                </Button>
                                            )}
                                    </>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </SideDrawer>
            <Styles />
        </>
    );
}
const grey = {
    50: "#F3F6F9",
    100: "#E5EAF2",
    200: "#DAE2ED",
    300: "#C7D0DD",
    400: "#B0B8C4",
    500: "#9DA8B7",
    600: "#6B7A90",
    700: "#434D5B",
    800: "#303740",
    900: "#1C2025",
};

const cyan = {
    50: "#E9F8FC",
    100: "#BDEBF4",
    200: "#99D8E5",
    300: "#66BACC",
    400: "#1F94AD",
    500: "#0D5463",
    600: "#094855",
    700: "#063C47",
    800: "#043039",
    900: "#022127",
};

function useIsDarkMode() {
    const theme = useTheme();
    return theme.palette.mode === "dark";
}

function Styles() {
    // Replace this with your app logic for determining dark mode
    const isDarkMode = useIsDarkMode();
    return (
        <style>{`
        .Button {
          font-family: 'IBM Plex Sans', sans-serif;
          font-weight: 600;
          font-size: 0.875rem;
          line-height: 1.5;
          background-color: ${cyan[500]};
          padding: 8px 16px;
          border-radius: 8px;
          color: white;
          transition: all 150ms ease;
          cursor: pointer;
          border: 1px solid ${cyan[500]};
          box-shadow: 0 2px 4px ${isDarkMode ? "rgba(0, 0, 0, 0.5)" : "rgba(13, 84, 99, 0.5)"
            }, inset 0 1.5px 1px ${cyan[400]}, inset 0 -2px 1px ${cyan[600]};

          &:hover {
            background-color: ${cyan[600]};
          }

          &:active {
            background-color: ${cyan[700]};
            box-shadow: none;
          }

          &:focus-visible {
            box-shadow: 0 0 0 4px ${isDarkMode ? cyan[300] : cyan[200]};
            outline: none;
            }
        }

        .CustomPopup{
          background-color: ${isDarkMode ? grey[900] : "#FFF"};
          border-radius: 8px;
          border: 1px solid ${isDarkMode ? grey[700] : grey[200]};
          box-shadow: ${isDarkMode
                ? `0 4px 8px rgb(0 0 0 / 0.7)`
                : `0 4px 8px rgb(0 0 0 / 0.1)`
            };
          padding: 0.75rem;
          color: ${isDarkMode ? cyan[100] : cyan[700]};
          font-size: 0.875rem;
          font-family: 'IBM Plex Sans', sans-serif;
          font-weight: 500;
          opacity: 1;
          margin: 0.5rem 0px;
        }
    `}</style>
    );
}
